export class ObjectUtils {

    public static deepAssign<T extends Object, S extends Object>(dest: T, src: S): T & S {
        if (<any>dest === src) {
            return <any>dest;
        }
        for (const key in src) {
            if (!src.hasOwnProperty(key)) {
                continue;
            }
            const srcVal = src[key];
            if (dest.hasOwnProperty(key)) {
                const destVal = (<any>dest)[key];
                if (ObjectUtils.isObject(destVal) && ObjectUtils.isObject(srcVal)) {
                    ObjectUtils.deepAssign(destVal, srcVal);
                } else {
                    (<any>dest)[key] = srcVal;
                }
            } else {
                (<any>dest)[key] = srcVal;
            }
        }
        return <any>dest;
    }

    public static isObject<T>(x: T | undefined | null | boolean | string | symbol | number): x is T {
        return typeof x === "object" ? x !== null : typeof x === "function";
    }

    public static arraysEqual(value1: any, value2: any, field?: string): boolean {
        if (value1 == undefined && value2 == undefined) {
            return true;
        }
        if (value1 == undefined || value2 == undefined) {
            return false;
        }
        if (typeof value1 != typeof value2) {
            return false;
        }
        if (value1.length === 0 && value2.length === 0) {
            return true;
        }
        return value1.length === value2.length && value1.every((v, i) => field ? v[field] === value2[i][field] : v === value2[i]);
    }
}
